// extracted by mini-css-extract-plugin
export default {"tabs":"DashboardTabs_tabs__9qFic","tab":"DashboardTabs_tab__4mN5Q","active":"DashboardTabs_active__A6XRY"};